export default __webpack_public_path__ + "images/742153ad1485c5db17b00ff14877a61c-diy.jpg";